<!-- Breadcrumb -->
<app-campaign-breadcrumb
  [stateAction]="this.stateAction"
  [messageInstanceId]="this.messageInstanceId"
  [campaignId]="this.campaignId"
  [actionId]="this.campaignActionid"
  [actualStep]="this.actualStep"
  [actionTypeCode]="actionTypeCode">
</app-campaign-breadcrumb>

<!-- Titolo -->
<div class="ui-g-12 campaign-step-title flex-align-center">
  <h2>{{ 'campaign.actionParamSetup' | translate }}</h2>
</div>
<!-- Selezione Message -->
<section class="ui-g-12" *ngIf="!update">
  <h3 class="section-title" *ngIf="actionTypeCode !== 'MSG'">{{ 'campaign.choseCouponType' | translate }}</h3>
  <h3 class="section-title" *ngIf="actionTypeCode === 'MSG'">{{ 'campaign.choseMsgType' | translate }}</h3>
  <div *ngIf="messages && messages.length > 0">
    <div class="ui-g-12 ui-md-5" *ngFor="let message of messages">
      <p-radioButton
        class="message-radio"
        name="message"
        value="{{message.value}}"
        label="{{message.label}}"
        (onClick)="getFields(message.value)">
      </p-radioButton>
    </div>
  </div>
</section>
<!-- Se update non si può modificare message -->
<section class="ui-g-12" *ngIf="update">
  <h3 class="section-title" *ngIf="selectedMessageId && messages && messages.length > 0">
    {{ 'campaign.communicationType' | translate }}: <span class="red">{{ getSelectedMessageDescription() }}</span>
  </h3>
</section>
<section style="padding: 0 15px;" *ngIf="targetLoyaltyClass === 'NOLOY' || targetLoyaltyClass === 'ALL'" class="ui-g-12">
  <p style="margin: 0;"><strong>{{ 'campaign.noLoyMsg' | translate }}</strong></p>
</section>
<form class="ui-g-12" *ngIf="messageInstanceForm && fields && MessageInstanceDtoSchema" [formGroup]="messageInstanceForm" [ngClass]="{'invalid-submit': invalidSubmit}">
  <section class="ui-g-12">
    <h3 class="section-title">
      {{ 'campaign.couponBaseParameters' | translate }}
    </h3>
    <!-- Tipo Promo -->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="fields.promo_type">
      <div class="ui-g-12 ui-md-2">
        <label [ngClass]="{'required': !MessageInstanceDtoSchema.promo_type_id.nullable}">{{ MessageInstanceDtoSchema.promo_type_id.keyName }}</label>
      </div>
      <div class="ui-g-12 ui-md-6">
        <p-dropdown [options]="promoTypes" formControlName="promo_type_id" [style]="{'width':'100%'}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="messageInstanceForm" [validation]="MessageInstanceDtoSchema.promo_type_id"></app-validation-msg>
      </div>
    </div>
    <!-- Valore Coupon -->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="fields.coupon_value">
      <div class="ui-g-12 ui-md-2" *ngIf="!fields.label_coupon_value">
        <label [ngClass]="{'required': !MessageInstanceDtoSchema.coupon_amt.nullable}">{{ MessageInstanceDtoSchema.coupon_amt.keyName }}</label>
      </div>
      <div class="ui-g-12 ui-md-2" *ngIf="fields.label_coupon_value">
        <label [ngClass]="{'required': !MessageInstanceDtoSchema.coupon_amt.nullable}">{{ MessageInstanceDtoSchema.coupon_amt.keyName }}({{fields.label_coupon_value }})</label>
      </div>
      <div class="ui-g-12 ui-md-2">
        <input type="number" pInputText formControlName="coupon_amt" step="1" style="max-width: 100%;">
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="messageInstanceForm" [validation]="MessageInstanceDtoSchema.coupon_amt"></app-validation-msg>
      </div>
      <!-- Valore di Soglia -->
      <div class="ui-g-12 ui-md-2" *ngIf="fields.shop_min">
        <label [ngClass]="{'required': !MessageInstanceDtoSchema.threshold_value.nullable}">{{ MessageInstanceDtoSchema.threshold_value.keyName }}</label>
      </div>
      <div class="ui-g-12 ui-md-2" *ngIf="fields.shop_min">
        <input type="number" pInputText formControlName="threshold_value" style="max-width: 100%;" step="1">
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="messageInstanceForm" [validation]="MessageInstanceDtoSchema.threshold_value"></app-validation-msg>
      </div>
      <!-- Button Accumulatori -->
      <div class="ui-g-12 ui-md-2" *ngIf="fields.acm_button">
        <button
          pButton
          (click)="goToAcm()"
          type="button"
          class="k-generic-btn"
          label="{{ 'customers.accumulators' | translate }}">
        </button>
      </div>
      <div class="ui-g-12 ui-md-2" *ngIf="acmListFilter.length>0" >
        <p-listbox
          [style]="{'width':'100%'}"
          [listStyle]="{'max-height':'70px'}"
          [options]="acmListFilter"
        >
        </p-listbox>
        <span class="input-error-notification" *ngIf="invalidSubmit && (!selectedDepartment || selectedDepartment.length === 0)">{{ 'common.required_error' | translate }}</span>
      </div>
    </div>
    <!-- Numero Uso Coupon -->
    <div class="ui-g-12 ui-md-10 flex-align-center" >
      <div class="ui-g-12 ui-md-2">
        <label>{{ 'campaign.numberUsesCoupon' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-3">
        <input pInputText type="number" min="1" name="couponUseNumber" [(ngModel)]="couponUseNumber" [ngModelOptions]="{standalone: true}" [disabled]="messageInstanceForm.get('flg_couponType').value || messageInstanceForm.get('flg_rolling').value" >
        <span class="input-error-notification" *ngIf="invalidSubmit && couponUseNumber < 1">{{ 'campaign.couponUseNumberValidator' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-3">
        <p-dropdown
          *ngIf="couponUseTypes && couponUseTypes.length > 0 && couponUseNumber > 1"
          class="coupon-dropdown"
          [options]="couponUseTypes"
          [style]="{'width':'100%'}"
          [(ngModel)]="couponUseType"
          [ngModelOptions]="{standalone: true}">
        </p-dropdown>
        <span class="input-error-notification" *ngIf="invalidSubmit && !couponUseType && couponUseNumber > 1">{{ 'campaign.couponUseTypeValidator' | translate }}</span>
      </div>
    </div>
    <!-- Moltiplica / Numero Coupon -->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="fields.mult">
      <div class="ui-g-12 ui-md-2">
        <label>{{ 'campaign.dynamicCoupon' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-2">
        <p-checkbox
          class="tp-checkbox"
          name="flg_dynamicCoupon"
          [binary]="true"
          formControlName="flg_dynamicCoupon"
          (onChange)="refreshDinamico()"
          [disabled]="checkDisable()"  >
        </p-checkbox>
      </div>
      <div class="ui-g-12 ui-md-2" *ngIf="messageInstanceForm.get('flg_dynamicCoupon').value">
        <label [ngClass]="{'required': !MessageInstanceDtoSchema.total_coupon_number.nullable}">{{ MessageInstanceDtoSchema.total_coupon_number.keyName }}</label>
      </div>
      <div class="ui-g-12 ui-md-3" *ngIf="messageInstanceForm.get('flg_dynamicCoupon').value">
        <input type="number" pInputText formControlName="total_coupon_number">
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="messageInstanceForm" [validation]="MessageInstanceDtoSchema.total_coupon_number"></app-validation-msg>
      </div>
    </div>
    <!-- Coupon Multipli-->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="fields.check_repeatable">
      <div class="ui-g-12 ui-md-2">
        <label>{{ 'campaign.multipleCoupon' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-2">
        <p-checkbox
          class="tp-checkbox"
          name="flg_couponType"
          formControlName="flg_couponType"
          [binary]="true"
          (onChange)="refreshMultupli()"
        >
        </p-checkbox>
      </div>
    </div>
    <!-- Coupon Rolling-->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="fields.flag_rolling">
      <div class="ui-g-12 ui-md-2">
        <label>{{ 'campaign.rollingCoupon' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-2">
        <p-checkbox
          class="tp-checkbox"
          name="flg_rolling"
          formControlName="flg_rolling"
          [binary]="true"
          (onChange)="refreshRolling()"
        >
        </p-checkbox>
      </div>
    </div>
    <!-- Soglia minima per attivazione coupon -->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="messageInstanceForm.get('flg_couponType').value">
      <div class="ui-g-12 ui-md-4">
        <label>{{ 'campaign.minimumThresholdActivation' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-2">
        <input type="number" pInputText formControlName="threshold_rule_value" step=".01" style="max-width: 100%;" min="0" oninput="validity.valid||(value='');">
        <span class="input-error-notification" *ngIf="invalidSubmit && !messageInstanceForm.get('threshold_rule_value').value">{{ 'common.required_error' | translate }}</span>
      </div>
    </div>
    <!-- Soglia per generazione nuovo coupon -->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="messageInstanceForm.get('flg_couponType').value">
      <div class="ui-g-12 ui-md-4">
        <label>{{ 'campaign.thresholdNewGeneration' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-2">
        <input type="number" pInputText formControlName="repetition_threshold" step=".01" style="max-width: 100%;" min="0" oninput="validity.valid||(value='');">
        <span class="input-error-notification" *ngIf="invalidSubmit && !messageInstanceForm.get('repetition_threshold').value">{{ 'common.required_error' | translate }}</span>
      </div>
    </div>
    <!-- Tipo di soglia -->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="messageInstanceForm.get('flg_couponType').value">
      <div class="ui-g-12 ui-md-4">
        <label>{{ 'campaign.thresholdType' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-2">
        <p-dropdown
          [options]="thresholdTypeList"
          formControlName="threshold_type"
          [style]="{'width':'100%'}"
          field="label">
        </p-dropdown>
        <span class="input-error-notification" *ngIf="invalidSubmit && !messageInstanceForm.get('threshold_type').value">{{ 'common.required_error' | translate }}</span>
      </div>
    </div>
    <!-- Numero massimo coupon emettibili -->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="messageInstanceForm.get('flg_couponType').value">
      <div class="ui-g-12 ui-md-4">
        <label>{{ 'campaign.maxCouponIssued' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-2">
        <input type="number" pInputText formControlName="max_coupon_number" step="1" style="max-width: 100%;" min="0" oninput="validity.valid||(value='');">
        <span class="input-error-notification" *ngIf="invalidSubmit && !messageInstanceForm.get('max_coupon_number').value">{{ 'common.required_error' | translate }}</span>
      </div>
    </div>
    <!-- Coupon Aperto
    <div class="ui-g-12 ui-md-10 flex-align-center">
      <div class="ui-g-12 ui-md-2" *ngIf="fields.repeat">
        <label>{{ MessageInstanceDtoSchema.flg_open_coupon.keyName }}</label>
      </div>
      <div class="ui-g-12 ui-md-3" *ngIf="fields.repeat">
        <p-checkbox
          class="tp-checkbox"
          name="flg_open_coupon"
          [binary]="true"
          formControlName="flg_open_coupon">
        </p-checkbox>
      </div>
    </div>-->
    <!-- Descrizione Paniere / Upload Paniere Articoli -->
    <div class="ui-g-12 ui-md-10 flex-align-center">
      <!-- Upload Paniere -->
      <div class="ui-g-12 ui-md-2" *ngIf="fields.basket_article">
        <label>{{ 'campaign.itemBasket' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-3" *ngIf="fields.basket_article">
        <small>{{ 'campaign.loadBasketFile' | translate }}</small>
        <p-fileUpload
          #itemBasketUploadRef
          name="itemBasketUpload"
          class="file-upload-item"
          chooseLabel="{{'upload.choose_file' | translate}}"
          customUpload="true"
          auto="true"
          (uploadHandler)="onItemBasketFileUpload($event)"
          (onRemove)="itemBasketFile = null"
          required="false"
          accept=".xls,.xlsx,.csv"
          [disabled]="this.messageInstanceForm.get('basket').value">
        </p-fileUpload>
      </div>
      <div class="ui-g-12 ui-md-2" *ngIf="fields.department">
        <label>{{ 'campaign.productDepartment' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-3" *ngIf="fields.department">
        <p-multiSelect
          [style]="{'width':'100%'}"
          [options]="departmentList"
          [(ngModel)]="selectedDepartment"
          [ngModelOptions]="{standalone: true}"
        >
        </p-multiSelect>
        <!--<span class="input-error-notification" *ngIf="invalidSubmit && (!selectedDepartment || selectedDepartment.length === 0)">{{ 'common.required_error' | translate }}</span>-->
      </div>
      <!-- Descrizione Paniere -->
      <div class="ui-g-12 ui-md-3" *ngIf="fields.basket_description && itemBasketFile">
        <label>{{ BasketDtoSchema.description.keyName }}</label>
      </div>
      <div class="ui-g-12 ui-md-3" *ngIf="fields.basket_description && itemBasketFile">
        <input type="text" pInputText formControlName="description">
        <span class="input-error-notification" *ngIf="invalidSubmit">{{ 'promotion.basketDescriptionMandatory' | translate }}</span>
      </div>
    </div>
    <!-- Selezione Paniere Esistente -->
    <div class="ui-g-12 ui-md-10 flex-align-center">
      <div class="ui-g-12 ui-md-2" *ngIf="fields.basket_description">
        <label>{{ 'campaign.selectItemBasket' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-4" *ngIf="fields.basket_description">
        <p-autoComplete
          id="basket-autocomplete"
          [style]="{'width':'100%'}"
          formControlName="basket"
          [suggestions]="basketList"
          (completeMethod)="getBasketList($event.query)"
          [dropdown]="true"
          [disabled]="itemBasketFile"
          field="label">
        </p-autoComplete>
      </div>
    </div>
    <!-- Tipo Esclusione -->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="fields.esclusion_type">
      <div class="ui-g-12 ui-md-2">
        <label>{{ 'campaign.typeExclusion' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-6">
        <p-dropdown [options]="exclusionTypes" formControlName="exclusion_type" [style]="{'width':'100%'}"></p-dropdown>
      </div>
    </div>
    <!-- Altri Vincoli -->
    <div class="ui-g-12 ui-md-10 flex-align-center" *ngIf="fields.other_constraint">
      <div class="ui-g-12 ui-md-2">
        <label>{{ 'campaign.otherConstraints' | translate }}</label>
      </div>
      <div class="ui-g-12 ui-md-6">
        <p-dropdown [options]="constraints" formControlName="other_constraints" [style]="{'width':'100%'}"></p-dropdown>
      </div>
    </div>
  </section>
  <!-- Save -->
  <section class="ui-g-12" style="padding-bottom: 100px;">
    <div class="ui-g-12 ui-md-10 text-right">
      <button
        pButton
        (click)="save()"
        type="button"
        class="k-generic-btn"
        label="{{ 'common.save' | translate }}">
      </button>
    </div>
  </section>
</form>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-parameters-setup/coupon-parameters-setup.component.html